module.exports = __webpack_public_path__ + "img/logout.7c4368c7.jpg";